export default __webpack_public_path__ + "static/media/Tecnologia_conectividad_tvs_ntorq_125.91c12bcf.jpg";